import { createContext, useContext, useState, useCallback } from "react";
import { translations, localize } from "@/i18n/translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("kw_lang") || "de");

  const change = useCallback((l) => {
    localStorage.setItem("kw_lang", l);
    setLang(l);
  }, []);

  const t = useCallback(
    (key) => (translations[lang] && translations[lang][key]) || translations.de[key] || key,
    [lang]
  );

  const L = useCallback((field) => localize(field, lang), [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang: change, t, L }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
